import React from 'react'
import PropTypes from 'prop-types'
import {Button, Flex, SimpleGrid, useMultiStyleConfig} from '@chakra-ui/react'
import {MenuCardGroup} from '../list-menu/menu-card-group'
import Link from '@salesforce/retail-react-app/app/components/link'
import {Link as RouteLink} from 'react-router-dom'
import {MenuCard} from '../list-menu/menu-card'
import TertiaryLink from '../list-menu/tertiary-link'
import {getGlobalLink} from '../../utils/contentstack-utils'

const DrawerMenuSecondLevel = ({secondLevel, categoriesData, categoryUrl}) => {
    const styles = useMultiStyleConfig('DrawerMenu')

    const tertiaryLinks = [
        secondLevel.footer?.tertiary_link_1[0],
        secondLevel.footer?.tertiary_link_2[0],
        secondLevel.footer?.tertiary_link_3[0],
    ].filter((link) => link)

    let content = null
    if (secondLevel.layout === 'Category') {
        const group = secondLevel.standard_group[0]
        const primaryCards = group.cards.filter((card) => !card.shownassecondaryctainmobilemenu)
        const secondaryCards = group.cards.filter((card) => card.shownassecondaryctainmobilemenu)
        const groupWithPrimaryCard = {...group, cards: primaryCards}

        content = (
            <>
                <MenuCardGroup
                    group={groupWithPrimaryCard}
                    categoriesData={categoriesData}
                    compact
                />
                <SimpleGrid {...styles.secondaryCardsGrid}>
                    {secondaryCards.map((card) => {
                        const {label, url, isAbsolute} = getGlobalLink({
                            link: card?.redirects,
                            categoriesData,
                        })
                        return (
                            <MenuCard
                                key={card.uid}
                                title={label || card?.link?.title}
                                url={url || card?.link?.href}
                                image={card?.icon}
                                isAbsolute={isAbsolute}
                                isLink
                                variant="secondary"
                            />
                        )
                    })}
                    {tertiaryLinks.map((link) => (
                        <TertiaryLink
                            key={link.uid}
                            link={link}
                            categoriesData={categoriesData}
                            asSecondaryCard
                        />
                    ))}
                </SimpleGrid>
                <MenuCardGroup
                    group={secondLevel.filters_group[0]}
                    categoriesData={categoriesData}
                    type="filter"
                />
            </>
        )
    }
    if (secondLevel.layout === 'Sub category') {
        content = secondLevel.sub_categories_group.map((group) => {
            return (
                <MenuCardGroup
                    key={group.uid}
                    group={group}
                    categoriesData={categoriesData}
                    type="subCategory"
                    compact
                />
            )
        })
    }
    if (secondLevel.layout === 'Promo/Gift') {
        content = (
            <>
                <MenuCardGroup
                    group={secondLevel.promos_group[0]}
                    categoriesData={categoriesData}
                    type="promo"
                    compact
                />
                {tertiaryLinks.map((link) => (
                    <TertiaryLink
                        key={link.uid}
                        link={link}
                        categoriesData={categoriesData}
                        asSecondaryCard
                    />
                ))}
            </>
        )
    }

    return (
        <Flex {...styles.secondLevelContainer}>
            {secondLevel?.footer?.show_explore_all && (
                <Link as={RouteLink} to={categoryUrl}>
                    <Button variant="primary" {...styles.secondLevelExploreAll}>
                        {secondLevel.footer?.explore_all_label}
                    </Button>
                </Link>
            )}
            <SimpleGrid {...styles.secondLevelGrid}>{content}</SimpleGrid>
        </Flex>
    )
}

DrawerMenuSecondLevel.displayName = 'DrawerMenuSecondLevel'

DrawerMenuSecondLevel.propTypes = {
    secondLevel: PropTypes.object,
    categoriesData: PropTypes.object,
    categoryUrl: PropTypes.string,
}

export {DrawerMenuSecondLevel}
